import type { GenericError } from '@atlassian/jira-servicedesk-knowledge-services/src/types.tsx';
import messages from './messages.tsx';

export const FETCH_ARTICLE_FAILURE =
	'state.actions.fetch-article-failure.FETCH_ARTICLE_FAILURE' as const;

export type FetchArticleArgs = {
	id: string;
	statusCode: number;
};

export type FetchArticleFailureAction = {
	type: typeof FETCH_ARTICLE_FAILURE;
	payload: {
		id: string;
	} & GenericError;
};

export const fetchArticleFailure = (opts: FetchArticleArgs): FetchArticleFailureAction => ({
	type: FETCH_ARTICLE_FAILURE,
	payload: {
		id: opts.id,
		error:
			opts.statusCode === 404
				? {
						message: messages.notFoundMessage,
						header: messages.notFoundHeader,
						ctaText: messages.genericSearchCta,
						ctaLink: '/knowledge',
					}
				: {
						message: messages.genericMessage,
						header: messages.genericHeader,
						ctaText: messages.genericSearchCta,
						ctaLink: '/knowledge',
					},
	},
});
